import { Component, OnInit, TemplateRef } from "@angular/core";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal"; 
import { HttpBackend, HttpClient, HttpParams } from "@angular/common/http";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";

@Component({
  selector: "app-job-preferences",
  templateUrl: "./job-preferences.component.html",
  styleUrls: ["./job-preferences.component.css"]
})
export class JobPreferencesComponent implements OnInit {
  workPlaceList:any=[{name:'Remote',selected:false},{name:'Onsite',selected:false},{name:'Hybrid',selected:false}]
  modalRef?: BsModalRef;
  form: FormGroup;
  addTour: FormGroup;
  addJob: FormGroup;
  showError = false;
  showLocError = false;
  showZipError = false;
  show = false;
  showJob = false;
  // allData
  allIndustry:any=[];
  allJobtitle:any=[];
  allTravel:any=[];
  allSecurity:any=[];
  allJobPreference:any=[];
  selectedSubCategories : any = []
  // allTourOfDuties:any=[];
  serviceList:any=[];
  allEmployee:any=[];
  // datepicker
  minDate = new Date();
	maxDate = new Date();
	today: Date | undefined;
  // add prefer-locatim
  showLocationError =false;
  tourEditingPosition = -1;
  locationEditingPosition = -1;
  title ="Add"
  // industry search
  userQuestion: string = "";
  userQuestionUpdate = new Subject<string>();
  addedIndus:any=[]
  // job search
  jobQues: string = "";
  salaryType = "Per Hour";
  jobQuesUpdate = new Subject<string>();
  addedJobs:any=[]
  // other click
  showOtherService: boolean =false;
   // get sub-category
   categoryId:any;
   allCat:any=[];
   allSubCat:any=[];
   subCat:boolean=false;
   dropdownSettingsIndustry:any;
   dropdownSettings:any;
   dropdownSettingJobTitle:any;
  selectedIndustriesDetails: any =[];
  selectedJobTitleDetails: any =[];
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService,private http: HttpClient, private handler: HttpBackend,) {
    this.form = this.formBuilder.group({
      industrySearch: [""],
      jobTitleSearch: [""],
      industryIds: ["", Validators.compose([Validators.required])],
      categoryId: ["", Validators.compose([Validators.required])],
      subCategoryId: [""],
      jobTitleIds: ["", Validators.compose([Validators.required])],
      employementTypeId: [""],
      employementType: [""],
      desiredSalary: [""],
      desiredSalaryType: ["Per Hour"],
      workPlace: [""],
      securityClearance: [""],
      serviceId: [""],
      otherServiceTitle: [""],
      travelRequirement: [""],
      willingToRelocate: [""],
      covidVaccinated: [""],
      locations: ["", Validators.compose([Validators.required])],
      tourOfDuties: [""],
      dateOfAvailability: [""],
      workAuthorization: ["", Validators.compose([Validators.required])],
    }); 
    this.addTour =this.formBuilder.group({
      location:["", Validators.compose([Validators.required])],
      zipCode:["", Validators.compose([Validators.required])],
      fromDate:["", Validators.compose([Validators.required])],
      toDate:["", Validators.compose([Validators.required])],
    });
    this.addJob =this.formBuilder.group({
      location:["", Validators.compose([Validators.required])],
      zipCode:["", Validators.compose([Validators.required])], 
      latitude:[""], 
      longitude:[""],
      state:[""],
      city:[""],
      country:[""],
    }); 
   }

  ngOnInit(): void {
    this.getJobPreference();
    this.getServices();
    this.getIndustry();
    this.getAllSecurityTravelRequirements();
    this.getEmpType();
    this.getCat(); 
    // this.userQuestionUpdate.pipe(
    //   debounceTime(400),
    //   distinctUntilChanged())
    //   .subscribe(value => {
    //     if(value == ""){
    //       this.allIndustry = [];
    //     } else{
    //       let params = new HttpParams(); 
    //     params = params.append("search", value);
    //     this.api.getData(apiUrl._getAllIndutry,params)
    //           .subscribe(async (res) => {
    //             this.allIndustry = [];
    //             res.data.industry.map((indus) => {
    //               let alreadyAdded = false;
    //               this.addedIndus.map((addedIndus)=> {
    //                 if (addedIndus.id == indus.id) {
    //                   alreadyAdded = true;
    //                 }
    //               })
    //               if (!alreadyAdded) {
    //                 this.allIndustry.push(indus);
    //               }
    //               this.show=true;
    //             })
                
    //       })
    //     }
        
    //   }); 
    //   this.jobQuesUpdate.pipe(
    //     debounceTime(400),
    //     distinctUntilChanged())
    //     .subscribe(value => {
    //       if(value == ""){
    //         this.allJobtitle = [];
    //       } else{
    //         let params = new HttpParams(); 
    //       params = params.append("search", value);
    //       this.api.getData(apiUrl._getAllIndutry,params)
    //             .subscribe(async (res) => {
    //               this.allJobtitle = [];
    //               res.data.jobtitle.map((jobs) => {
    //                 let alreadyAdded = false;
    //                 this.addedJobs.map((addedJob)=> {
    //                   if (addedJob.id == jobs.id) {
    //                     alreadyAdded = true;
    //                   }
    //                 })
    //                 if (!alreadyAdded) {
    //                   this.allJobtitle.push(jobs);
    //                 }
    //                 this.showJob=true;
    //               })
                  
    //         })
    //       }
          
    //     });
        
    this.dropdownSettingsIndustry = {
			singleSelection: false,
			idField: "id",
			textField: "name",
			itemsShowLimit: 2,
			allowSearchFilter: true,
			closeDropDownOnSelection: true,
      unSelectAllText: "Unselect All",
      noDataAvailablePlaceholderText: "No data available",
      enableCheckAll: false,
		};
    this.dropdownSettingJobTitle = {
			singleSelection: false,
			idField: "id",
			textField: "name",
			itemsShowLimit: 2,
			allowSearchFilter: true,
			closeDropDownOnSelection: true,
      unSelectAllText: "Unselect All",
      noDataAvailablePlaceholderText: "No data available",
      enableCheckAll: false,
      limitSelection:51
		};
    this.dropdownSettings = {
			singleSelection: false,
			idField: "id",
			textField: "name",
			itemsShowLimit: 2,
			allowSearchFilter: true,
			closeDropDownOnSelection: true,
      unSelectAllText: "Unselect All",
      noDataAvailablePlaceholderText: "No data available",
      enableCheckAll: false,
		};
  }
  // date picker only accpedct number
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    if (!/^\d+$/.test(key)) {
      event.preventDefault();
    }
  }
// category
getCat(){
  // this.api.stopLoader(); 
  this.api.getDatas(apiUrl._jobcategories)
  .subscribe(async (res) => {
    this.allCat = res.data.data;
   })
} 
selectCategoryId(event){
  this.categoryId =event.target.value
  this.subCat=true; 
  this.allSubCat = []
  this.form.patchValue({
    subCategoryId: []
  })
  this.getSubCat()
}
// sub-category
getSubCat(){
  // this.api.stopLoader(); 
  let params = new HttpParams(); 
  params = params.append("categoryId", this.categoryId);
  this.api.getData(apiUrl._jobgetSubCategories,params)
  .subscribe(async (res) => { 
    this.allSubCat = res.data.data;

    if (this.selectedSubCategories.length > 0){
    let subCategoryIds:any=[]; 
    this.allSubCat.map((subcat) => { 
      this.selectedSubCategories.map((addedCat) => {
        if (subcat.id == addedCat.subCategoryId) {
          this.subCat = true;
          subCategoryIds.push({name: addedCat.jobPreferenceSubCategories.name, id: addedCat.subCategoryId});
        }
      }) 
    }) 
    this.form.patchValue({
      subCategoryId :subCategoryIds
    })
  }
  })
} 
  // ============ Multiple dropdown functionality =============
  onItemSelect(item: any) {}
  onItemDeSelect(item: any) {}
  onDeSelectAll(item:any) {
    this.form.patchValue({
      subCategoryId: []
    })
  }
  onSelectAll(items: any) {
    let data:any = []
    for (let i = 0; i < items.length; i++) {
      data.push(items[i])
    }
    this.form.patchValue({
      subCategoryId: data
    })
  }
  // industry
  getIndustry(){
    // this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getAllIndutry)
    .subscribe(async (res) => {
      this.allIndustry = res.data?.industry;
      this.allJobtitle = res.data?.jobtitle;
      
    if (this.selectedIndustriesDetails?.length > 0){
      let IndustriesDetailsIds:any=[]; 
      this.allIndustry.map((industryid) => { 
        this.selectedIndustriesDetails.map((addedIndustry) => {
          if (industryid.id == addedIndustry.industryDetails.id) {
            IndustriesDetailsIds.push({name: addedIndustry.industryDetails.name, id: addedIndustry.industryDetails.id});
          }
        }) 
      }) 
      this.form.patchValue({
        industryIds :IndustriesDetailsIds
      })
    }
    if (this.selectedJobTitleDetails?.length > 0){
      let JobTitleDetailsIds:any=[]; 
      this.allJobtitle.map((jobTitleId) => { 
        this.selectedJobTitleDetails.map((addedJobTitle) => {
          if (jobTitleId.id == addedJobTitle.JobTitleDetails.id) {
            JobTitleDetailsIds.push({name: addedJobTitle.JobTitleDetails.name, id: addedJobTitle.JobTitleDetails.id});
          }
        }) 
      }) 
      this.form.patchValue({
        jobTitleIds :JobTitleDetailsIds
      })
    }
     })
  }
  search() {
    this.userQuestionUpdate.next(this.userQuestion)
  }
  searchJob() {
    this.jobQuesUpdate.next(this.jobQues)
  }
  drop(){
    this.show=false;
  }
  dropJob(){
    this.showJob=false;
  }
  selectedSkill(i){
    this.addedIndus.push(this.allIndustry[i])
    this.allIndustry.splice(i,1) 
  }
  // selectedJobs(i){
  //   this.addedJobs.push(this.allJobtitle[i])
  //   this.allJobtitle.splice(i,1) 
  // }
  removeSkills(i){
    this.addedIndus.splice(i,1)
  }
  removeJob(i){
    this.addedJobs.splice(i,1)
  }
  getAllSecurityTravelRequirements(){
    // this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getAllSecurityTravelRequirements)
    .subscribe(async (res) => {
      this.allTravel = res.data.travel;
      this.allSecurity = res.data.securityClearance;
     })
  }
  
  getJobPreference(){
    // this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getJobPreference)
    .subscribe(async (res) => {
      this.getIndustry();
      if(res.data != null || res.data != ""){
      this.allJobPreference = res.data.getJobPreference[0]; 
      this.selectedIndustriesDetails = res.data.getJobPreference[0]?.jobPreferenceIndustriesDetails;
      this.selectedJobTitleDetails = res.data.getJobPreference[0]?.jobPreferenceJobTitleDetails;
      this.selectedSubCategories = res.data.subCategory;
      // this.allEmployee.map((emp)=>{
      //   if(emp.id == this.allJobPreference?.employementTypeDetails?.id){
      //     emp["selected"] = true
      //   }
      // }) 
      let array=[]
      if(this.allJobPreference?.workPlace!=''){
        array=this.allJobPreference?.workPlace.split(',')
      }
      // console.log(array,this.allJobPreference.workPlace)
      this.workPlaceList.map((e)=>{
        array.map((x)=>{
          if(e.name == x){
            e["selected"] = true
          }
        })
      }) 
      this.allEmployee.map((e)=>{
        this.allJobPreference.employmentTypeMultipleDetail.map((x)=>{
          if(e.id == x.employmentTypeId){
            e["selected"] = true
          }
        })
      }) 
      this.allTravel.map((travel)=>{
        this.allJobPreference?.jobPreferenceTravelRequirementsDetails.map((selectedTrav)=>{
          if(travel.id == selectedTrav.travelRequirementsDetails?.id){
            travel["selected"] = true
          }
        })
      }) 
      this.allSecurity.map((sec)=>{
        this.allJobPreference?.jobPreferenceSecurityClearanceDetails.map((selectedSec)=>{
          if(sec.id == selectedSec.securityClearanceDetails?.id){
            sec["selected"] = true
          }
        })
      })
      
    this.categoryId = res.data.categories[0].categoryId;
    this.getSubCat();
      this.form.patchValue({
        ...this.allJobPreference,
        dateOfAvailability : this.allJobPreference?.dateOfAvailability ? new Date(this.allJobPreference?.dateOfAvailability) : "",
        securityClearance : this.allJobPreference?.jobPreferenceSecurityClearanceDetails,
        locations : this.allJobPreference?.jobPreferenceLocationDetails,
        desiredSalary : this.allJobPreference?.desiredSalary?(this.allJobPreference?.desiredSalary.toString()):"",
        categoryId : res.data.categories[0]?.categoryId,
        tourOfDuties: res.data.userTourOfDuties,
      })

    } else{ 
      this.getIndustry();
    }
     })
    
  }
// getUniSpec
getEmpType(){
  // this.api.stopLoader(); 
  this.api.getDatas(apiUrl._allEmpType)
  .subscribe(async (res) => {
    this.allEmployee = res.data.listing;
   })
} 
  getServices(){ 
    // this.api.stopLoader(); 
    this.api.getDatas(apiUrl._commonServices)
      .subscribe(async (res) => {
        this.serviceList=res.data.listing;
      }, err => {
          this.toastrService.error("Error", err.error.message)
    })
  }
  selectedService(event){
    this.serviceList.map((uni)=>{
      if(event == uni.id && uni.name == "Other"){
        this.showOtherService = true;
      } else{this.showOtherService= false}
    })
  }
// selected employee
selectedEmployment(i,event){ 
  this.allEmployee.map((emp)=>{
    emp["selected"] = false
    event.srcElement.classList.remove("selected")
  })
  this.allEmployee[i]["selected"] = true
  event.srcElement.classList.add("selected")
}
// selected Travel
selectedTravel(i,event){ 
  if (this.allTravel[i]["selected"]) {
    this.allTravel[i]["selected"] = false
    event.srcElement.classList.remove("selected")
  } else {
    this.allTravel[i]["selected"] = true
    event.srcElement.classList.add("selected")
  }
  
}
// selected Employment Type Multiple
selectedEmploymentType(i,event){ 
  if (this.allEmployee[i]["selected"]) {
    this.allEmployee[i]["selected"] = false
    event.srcElement.classList.remove("selected")
  } else {
    this.allEmployee[i]["selected"] = true
    event.srcElement.classList.add("selected")
  }
  console.log(this.allEmployee,"====eee")
}
// selected Security
selectedSecurity(i,event){ 
  if (this.allSecurity[i]["selected"]) {
    this.allSecurity[i]["selected"] = false
    event.srcElement.classList.remove("selected")
  } else {
    this.allSecurity[i]["selected"] = true
    event.srcElement.classList.add("selected")
  }
  
}
// jobs prefer
openTourDuty(addTourDuty: TemplateRef<any>) { 
  this.addTour.reset()
  this.tourEditingPosition = -1;
  this.modalRef = this.modalService.show(
    addTourDuty,
    Object.assign({}, { class: "modal-lg addModal centerAlign" })
  );
}
// TourDuty
onTourDuty(){
  this.title="Add";
  if(this.addTour.valid){
    let location = this.form.value.tourOfDuties;
    if (this.tourEditingPosition == -1) {
      if (location == "") {
        location = [];
      }
      location.push({
        location: this.addTour.value.location,
        zipCode: this.addTour.value.zipCode,
        fromDate: this.addTour.value.fromDate,
        toDate: this.addTour.value.toDate,
      });
    } else {
      location[this.tourEditingPosition] = {
        location: this.addTour.value.location,
        zipCode: this.addTour.value.zipCode,
        fromDate: this.addTour.value.fromDate,
        toDate: this.addTour.value.toDate,
      }
      this.tourEditingPosition = -1;
    }
  
    this.form.patchValue({
      tourOfDuties: location
    }) 
    
    this.modalRef?.hide()
    this.addTour.reset();
  } else{
    this.showError=true;
    setTimeout(() => {
      this.showError=false
    }, 3000);
  }
}
editTour(i,template: TemplateRef<any>){
  this.title="Edit";
  this.tourEditingPosition=i
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal centerAlign" })
  );
  setTimeout(() => {
    this.addTour.patchValue(this.form.value.tourOfDuties[i])
  }, 200);
}
deleteTour(i){
  let location = this.form.value.tourOfDuties;
  location.splice(i,1)
  this.form.patchValue({
    tourOfDuties: location
  })
}
// jobs prefer
 openPreferredLocation(addJobs: TemplateRef<any>) {  
  this.addJob.reset();
  this.title="Add";
  this.modalRef = this.modalService.show(
    addJobs,
    Object.assign({}, { class: "modal-lg addModal centerAlign" })
  );
}
// add jobs
onAddJobs(){ 
  this.getLatLongFromZipCode(this.addJob.value.zipCode,this.addJob.value.location)
  
}
editMember(i,template: TemplateRef<any>){ 
  this.title="Edit";
  let loc = this.form.value.locations[i];
  this.locationEditingPosition=i
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal centerAlign" })
  );
  setTimeout(() => {
    this.addJob.patchValue(loc.value)
  }, 200);
  
  
}
deleteMember(i){
  let location:any=[];
  location = this.form.value.locations;
  location.splice(i,1)
  this.form.patchValue({
    locations: location
  })
}
// check if only number
  preventNumbers(event): boolean { 
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
  // on submit
  onSubmit(){
    // console.log(this.form.value, this.form.value.jobTitleIds?.length <= 50)
    delete this.form.value.industrySearch
    delete this.form.value.jobTitleSearch
    if(this.form.valid && this.form.value.locations != "" && this.form.value.jobTitleIds?.length <= 50){
    let employeeType = ""
    this.allEmployee.map((employee) => {
      if(employee["selected"] == true) {
        if (employeeType == "") {
          employeeType = employee.id
        } else {
          employeeType = employeeType + "," + employee.id
        }
      }
    }) 
    if(this.showOtherService == true && this.form.value.otherServiceTitle == ""){
      this.showError= true;
      return
    } else{
      this.showError=false
    }
    this.form.patchValue({
      // employementTypeId:employeeType,
      desiredSalary:this.form.value.desiredSalary,
    }) 
    let empType:any=[]
    this.allEmployee.map((x) => {
      if(x["selected"] == true) {
        empType.push({"employmentTypeId":x.id,"name":x.name})
      }
    }) 
    this.form.patchValue({
      employementType:empType
    })
    let travel:any=[]
    this.allTravel.map((tra) => {
      if(tra["selected"] == true) {
        travel.push({"travelRequirementId":tra.id,"otherTitle":tra.name})
      }
    }) 
    this.form.patchValue({
      travelRequirement:travel
    }) 
    let security:any= []
    this.allSecurity.map((sec) => {
      if(sec["selected"] == true) {
        security.push({"securityClearanceId":sec.id,"otherTitle":sec.name})
      }
    }) 
    this.form.patchValue({
      securityClearance:security
    })    
      
      let subCategory:any=[];
      
      if(this.form.value.subCategoryId != ""){
        this.form.value.subCategoryId.map((subcat)=>{
          subCategory.push({"categoryId":this.categoryId,"subCategoryId":subcat.id}); 
        })
      }
      
      let idustryIds: any = []
      if(this.form.value.industryIds != ""){
        this.form.value.industryIds.map((indus)=>{
          idustryIds.push({"industryId":indus.id,"otherTitle":indus.name})
        })
      }
      let jobIds: any = []
      if(this.form.value.jobTitleIds != ""){
        this.form.value.jobTitleIds.map((job)=>{
          jobIds.push({"jobTitleId":job.id,"otherTitle":job.name})
        })
      }
      this.form.patchValue({
        industryIds: idustryIds,
        jobTitleIds: jobIds,
        subCategoryId: subCategory
      })
      let workPlaceType = ""
    this.workPlaceList.map((employee) => {
      if(employee["selected"] == true) {
        if (workPlaceType == "") {
          workPlaceType = employee.name
        } else {
          workPlaceType = workPlaceType + "," + employee.name
        }
      }
    })
    this.form.value.workPlace =workPlaceType;
      
      this.api.postData(apiUrl._addJobPreferenceV1, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => {
        this.toastrService.success("", "Job preferences added successfully.");
        this.router.navigate(["/overview"]);
      })
    } else{
      this.showError= true;
      this.showLocError= true;
      setTimeout(() => {
        this.showError= false;
        this.showLocError= false;
      }, 3000);
    }
  }

  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }

  // get current location 
  getLatLongFromZipCode(zipCode: string,location:any) {
    fetch("https://maps.googleapis.com/maps/api/geocode/json?address="+zipCode+ "&key=AIzaSyCDi96O9BAjbJUHBC-DTtw4QNmo3ekxIgA")
    .then(response => response.json())
    .then(data => { 
      if(location && data.results == ""){
        this.showLocationError = true
        setTimeout(() => {
          this.showLocationError=false;
        }, 3000);
        return
      }
      let state;
      let city;
      let country;
      for (let i = 0; i < data.results.length; i++){
        for (let j = 0; j < data.results[i].address_components.length; j++){
          if (data.results[i].address_components[j].types.includes("postal_code")) {
            zipCode = data.results[i].address_components[j].long_name;
          } else if (data.results[i].address_components[j].types.includes("administrative_area_level_1")) {
            state = data.results[i].address_components[j].long_name;
          }else if (data.results[i].address_components[j].types.includes("locality")) {
            city = data.results[i].address_components[j].long_name;
          }else if (data.results[i].address_components[j].types.includes("country")) {
            country = data.results[i].address_components[j].long_name;
          }
        }
      } 
      this.addJob.patchValue({
        location : data.results[0]?.formatted_address,
        state :state,
        city :city,
        country :country,
        latitude : data.results[0]?.geometry.location.lat.toString(),
        longitude : data.results[0]?.geometry.location.lng.toString(),
        zipCode : zipCode
      })
      this.addLocationToForm()
    })
  }

  addLocationToForm() {
  if(this.addJob.valid){
    let location = this.form.value.locations;
    if (location == undefined) {
      location = []
    }
    if (this.locationEditingPosition == -1) {
      if (location == "") {
        location = [];
      }
      location.push({
        ...this.addJob.value,
        
      });
      
    } else {
      location[this.locationEditingPosition] = {
        location: this.addJob.value.location,
        zipCode: this.addJob.value.zipCode
      }
      this.locationEditingPosition = -1;
    }
    this.form.patchValue({
      locations: location
    }) 
    this.modalRef?.hide() 
    
  } else{ 
    this.showZipError = true;
    setTimeout(() => { 
      this.showZipError = false;
    }, 3000);
  }
  }
  // selected workPlace List
  selectedworkPlaceList(i,event){ 
    if (this.workPlaceList[i]["selected"]) {
      this.workPlaceList[i]["selected"] = false
      event.srcElement.classList.remove("selected")
    } else {
      this.workPlaceList[i]["selected"] = true
      event.srcElement.classList.add("selected")
    }
  }
}